import { Helmet } from "react-helmet"
import Add from "./components/add"
import { getTranslation } from "../../heplers/translationHelper"
import { useEffect, useState } from "react";
import { MyTable } from "../../components";
import AlertDialog from "../../components/DeleteDialog";
import { useSnackbar } from "notistack";
import { Get, Post } from "../../actions";
import { IconButton, Link, Switch, Typography } from "@material-ui/core";
import { SwapHoriz } from "@material-ui/icons";
import { RiPencilFill } from "react-icons/ri";
import SubscriptionDialog from "./components/SubscriptionDialog";
import { set } from "lodash";

export const List=()=>{
  const [data, setData] = useState([]);
      const [queryParams, setQueryParams] = useState({
        pageSize: 10,
        pageNumber: 0,
        searchString: "",
      });
      const [openEditDialog, setOpenEditDialog] = useState(false);
      const [formData, setFormData] = useState(null);
      const [isLoadingCustomers, setIsLoadingCustomers] = useState(false);

     const [openDeleteModal, setOpenDeleteModal] = useState(false);
     const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false);
      const [isDeleting, setIsDeleting] = useState(false);
      const [isSubmitting, setIsSubmitting] = useState(false);
      const { enqueueSnackbar } = useSnackbar();
      const [customers, setCustomers] = useState({data:[],totalCount:0});
    
      const handlePageChange = (e, page) => {
        setQueryParams({ ...queryParams, pageNumber: page });
      };
    
      const handleSearch = (e) => {
        setQueryParams({ ...queryParams, searchString: e });
      };
    
      const handleRowsPerPageChange = (e) => {
        setQueryParams({ ...queryParams, pageSize: e.target.value });
      };
    
      const handleDelete = () => {
        // setIsDeleting(true);
        // Get(
        //   formData,
        //   Delete_Customers_URL,
        //   null,
        //   (res) => {
        //     setIsDeleting(false);
        //     enqueueSnackbar(
        //       getTranslation(
        //         "Deleted Successfully",
        //         "Deleted Successfully",
        //         "Deleted Successfully"
        //       ),
        //       {
        //         variant: "success",
        //       }
        //     );
        //     setOpenDeleteModal(false);
        //     setQueryParams({ ...queryParams, pageNumber: 0 });
        //   },
        //   (err) => {
        //     setIsDeleting(false);
        //     enqueueSnackbar(
        //       err.data
        //         ? err.data
        //         : getTranslation(
        //             "Something went wrong. Please Try Again.",
        //             "Something went wrong. Please Try Again.",
        //             "Something went wrong. Please Try Again."
        //           ),
        //       {
        //         variant: "error",
        //       }
        //     );
        //   }
        // );
      };

useEffect(() => {
  getAllRestaurants(queryParams);
}, [queryParams]);

const getAllRestaurants = (queryParams) => {
  Get(queryParams, "Restaurant/GetAllRestaurants", null, (resp) => {
        console.log("API Response:", resp); 
        
    const filteredData = resp.data.filter(item =>
      item.name?.toLowerCase().includes(queryParams.searchString.toLowerCase())
    );

    setCustomers({
      data: filteredData,
      totalCount: filteredData.length,
    });
  }, (error) => {
    console.error("Error fetching restaurants:", error);
  });
}


const handleStatusChange = (id, currentStatus) => {
  const payload = {
    id: id,
    isActive: !currentStatus,
  };

  Post(
    payload,
    "Restaurant/ChangeRestaurantStatus",
    null,
    (resp) => {
      Get(queryParams, "Restaurant/GetAllRestaurants", null, (resp) => {
        console.log("API Response:", resp); 
        setCustomers({
          data: resp.data,  
          totalCount: resp.totalCount,     
        });
      }, (error) => {
        console.error("Error fetching restaurants:", error);
      });
    },
    (error) => {
      // Error callback - add your own error handling here
      console.error("Failed to update status");
    }
  );
};

      const handleSubmitUpsert = (values,actions) => {
        actions.setSubmitting(true);
        Post(
          values,
          formData?.id ? "Restaurant/UpdateRestaurant":"Restaurant/InsertRestaurant",
          null,
          (resp) => {
            actions.setSubmitting(false);
            enqueueSnackbar(getTranslation(formData?.id? "Restaurant updated successfully!" : "Restaurant added successfully!"), { variant: "success" });
            setOpenEditDialog(false);
            // if(values.packageType==1 && formData==null){
            //   window.location.href=resp.data
            // }
            setFormData(null)
            // Refresh restaurant list
           
            Get(queryParams, "Restaurant/GetAllRestaurants", null, (resp) => {
              setCustomers({ data: resp.data, totalCount: resp.data.length });
            });
          },
          (error) => {
            enqueueSnackbar(getTranslation("Restaurant already exists."), { variant: "error" });
            actions.setSubmitting(false);
          }
        );
      };

      const columns = [
        {
          label: getTranslation("Restaurant Name"),  
          id: "name",  
          component: ({ row }) => <Link href="#" onClick={() => {
              setFormData(row);
              setOpenEditDialog(true);
            }}>{row.name}</Link>,
        },
        
        // {
        //   label: getTranslation("Roles", "Roles", "Roles"),
        //   id: "Roles",
        //   component: ({ row }) => <Typography>{row.phone}</Typography>,
        // },
        {
          label: getTranslation("Description"),  
          id: "description",  
          component: ({ row }) => <Typography>{row.description}</Typography>,
        },
        {
          label: getTranslation("Owner Name"),  
          id: "name",  
          component: ({ row }) => <Typography>{row.owner.fullName}</Typography>,
        },
        {
          label: getTranslation("Email"),  
          id: "name",  
          component: ({ row }) => <Typography>{row.owner.email}</Typography>,
        },
       
        {
          label: getTranslation("Zip Code"),  
          id: "name",  
          component: ({ row }) => <Typography>{row.owner.zipCode}</Typography>,
        },
               
        {
          label: getTranslation("Subscription"),  
          id: "name",  
          component: ({ row }) => <Typography >{row.packageType==0?getTranslation("All In"):getTranslation("Subscribed")} <IconButton size="small"
          onClick={()=>{
            setFormData(row);
            setOpenSubscriptionModal(true)
          }}><RiPencilFill /> </IconButton></Typography>,
        },
      
        {
          label: getTranslation("Status"),
          id: "actions",
          // component: ({ row }) => (
          //   <Switch
          //     checked={row.isActive}
          //     onChange={() => handleStatusChange(row.id, row.isActive)}
          //     color="primary"
          //   />
          // ),
        }, 
        
        ];
      
    
    return (
      <>
        <div>
          <Helmet>
            <title>
              {getTranslation("Restaurant Management", "Restaurant Management", "Restaurant Management")}
            </title>
          </Helmet>

          <MyTable
            title={getTranslation("Restaurant Management", "Restaurant Management", "Restaurant Management")}
            loading={isLoadingCustomers}
            viewSearch
            onSearch={handleSearch}
            colums={columns}
            rowsPerPage={queryParams.pageSize}
            handleChangePage={handlePageChange}
            handleChangeRowsPerPage={handleRowsPerPageChange}
            page={queryParams.pageNumber}
            rows={customers.data}
            count={customers.totalCount}
            // viewEdit
            // onEdit={(row) => {
            //   setFormData(row);
            //   setOpenEditDialog(true);
            // }}
            onCreate={() => {
              setOpenEditDialog(true);
              // setFormData({
              //   firstName: "",
              //   lastName: "",
              //   email: "",
              //   password:"",
              //   confirmPassword:"",
              //   name:"",
              //   description:""
              // });
            }}
            viewCreate
            actions={[
              {
                component: (row) => <Switch
                  checked={row.isActive}
                  onChange={() => handleStatusChange(row.id, row.isActive)}
                  color="primary"
                />
              }
            ]}
          />
          <Add
            formData={formData}
            open={openEditDialog}
            onClose={() => {
              setOpenEditDialog(false);
              setFormData(null);
            }}
            onSubmit={handleSubmitUpsert}
          />
          <AlertDialog
            open={openDeleteModal}
            onClose={() => setOpenDeleteModal(false)}
            deleting={isDeleting}
            onSubmit={handleDelete}
          />
           <SubscriptionDialog
        open={openSubscriptionModal}
        onClose={() => {
          setOpenSubscriptionModal(false)
          setFormData(null);
          getAllRestaurants(queryParams);
        }}
        packageType={formData?.packageType}
        onNotice={formData?.OnNoticePeriod}
        id={formData?.id}
      />
          {/* <CustomersTable
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        isLoadingCustomers={isLoadingCustomers}
        stat={stat}
        customers={customers}
        formData={formData}
        setFormData={setFormData}
        setIsEdit={setIsEdit}
      /> */}
        </div>
      </>
    );
}

